import Loadable from "@loadable/component";

const StoreLocatorPage = Loadable(
  () => import(/* webpackChunkName: "store_locator_page" */ "./storeLocator")
);

export default StoreLocatorPage;
